import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../shared/spinner.component';

import { waitForSpinnerToShowUp } from '../../shared/cursorHelpers';

import DropdownMenu from '../../shared/dropdownMenu';

class HamburgerDropdown extends PureComponent {
  static propTypes = {
    cannotDownloadAccountBalances: PropTypes.bool.isRequired,
    downloadAccountBalances: PropTypes.func.isRequired,
  };

  state = {
    isGeneratingXlsxFile: false,
  };

  hideDropDown = () => {
    this.dropdown.hideDropDown();
  };

  downloadAccountBalances = () => {
    this.setState({ isGeneratingXlsxFile: true }, () => {
      waitForSpinnerToShowUp({
        action: this.props.downloadAccountBalances,
        callback: () => {
          this.hideDropDown();
          this.setState({ isGeneratingXlsxFile: false });
        },
      });
    });
  };

  render() {
    const { isGeneratingXlsxFile } = this.state;

    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        {this.props.cannotDownloadAccountBalances ? null : (
          <button
            className="hamburger-action link-button"
            tabIndex="0"
            onClick={this.downloadAccountBalances}
          >
            {isGeneratingXlsxFile
              ? (
                <span>
                  <Spinner small/> Exporting
                </span>
              )
              : 'Export to Excel'
            }
          </button>
        )}
      </DropdownMenu>
    );
  }
}

export default HamburgerDropdown;
